import dayjs from "dayjs";


export function formatDate(value?: string | null, format = "MMMM, YYYY") {
  if (value) {
    return dayjs(value).format(format);
  }

  return value;
}